import {
  CASE_GET_ALL_TEMPLATES,
  CASE_ADD_TEMPLATE,
  GET_CASE_TEMPLATE,
  CASE_TEMPALTE_DETAILS,
  CASE_GET_TEMPLATE,
} from '../types'

const INITIAL_STATE = {
  caseGetAlltemplate: [],
  caseAddTemplate: [],
  getCaseTemplate: [],
  caseTemplateDetails: [],
  caseGetTemplate: [],
  selectedTemplateValue: [],
}

const caseTemplateReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CASE_GET_ALL_TEMPLATES:
      return {
        ...state,
        getAlltemplate: payload.data,
      }
    case CASE_ADD_TEMPLATE:
      return {
        ...state,
        caseAddTemplate: payload.data,
      }
    case GET_CASE_TEMPLATE:
      return {
        ...state,
        getCaseTemplate: payload.data,
      }
    case CASE_TEMPALTE_DETAILS:
      return {
        ...state,
        getCaseTemplate: payload.data.template,
      }
    case CASE_GET_TEMPLATE:
      return {
        ...state,
        caseGetTemplate: payload.data,
      }
    default:
      return state
  }
}

export default caseTemplateReducer
